<iframe
  [src]="src$ | async"
  width="600"
  height="450"
  frameborder="0"
  style="border: 0"
  allow="fullscreen"
  [attr.data-testid]="'location-map-iframe'"
></iframe>
<h3 [attr.data-testid]="'location-content'">{{ message.content.content }}</h3>
